module.exports = __webpack_public_path__ + "img/EPS.29945250.png";